import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import axios from "axios";

const ManageCategory = () => {
  const [categories, setCategories] = useState([]);
  const [addName, setAddName] = useState("");
  const [addDesc, setAddDesc] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [catMessage, setCatMessage] = useState("");
  const [catLoading, setCatLoading] = useState(false);

  const host = import.meta.env.VITE_HOST;
  const port = import.meta.env.VITE_PORT;
  const baseUrl = `${host}:${port}/api/v1/categories`;

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseUrl}/get_category`);
      if (response.status === 200 && response.data.status === "OK") {
        setCategories(response.data.data);
      } else {
        setCatMessage("Errore nel caricamento delle categorie.");
      }
    } catch (error) {
      console.error("Errore fetch categorie:", error);
      setCatMessage("Errore nel caricamento delle categorie.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Add category handler
  const handleAddCategory = async (e) => {
    e.preventDefault();
    setCatMessage("");
    setCatLoading(true);

    if (!addName.trim() || !addDesc.trim()) {
      setCatMessage("Inserisci nome e descrizione categoria");
      setCatLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("jwt_token");
      const response = await axios.post(
        `${baseUrl}/add_category`,
        {
          name: addName.trim(),
          description: addDesc.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200 && response.data.status === "OK") {
        setCatMessage("✅ Categoria aggiunta con successo");
        setAddName("");
        setAddDesc("");
        fetchCategories();
      } else {
        setCatMessage(`❌ Errore: ${response.data.message || "Errore sconosciuto"}`);
      }
    } catch (error) {
      console.error("Errore aggiunta categoria:", error);
      setCatMessage("Errore server durante l'aggiunta");
    } finally {
      setCatLoading(false);
    }
  };

  // Remove category handler
  const handleRemoveCategory = async () => {
    if (!selectedCategoryId) {
      setCatMessage("❌ Seleziona una categoria da eliminare");
      return;
    }
    setCatMessage("");
    setCatLoading(true);

    try {
      const token = localStorage.getItem("jwt_token");
      const response = await axios.delete(`${baseUrl}/delete_category`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          category_id: parseInt(selectedCategoryId, 10),
        },
      });

      if (response.status === 200 && response.data.status === "OK") {
        setCatMessage("✅ Categoria rimossa con successo");
        setSelectedCategoryId("");
        fetchCategories();
      } else {
        setCatMessage(`❌ Errore: ${response.data.message || "Errore sconosciuto"}`);
      }
    } catch (error) {
      console.error("Errore rimozione categoria:", error);
      if (error.response && error.response.data) {
        setCatMessage(`Errore: ${error.response.data.detail || error.response.data.message || "Bad Request"}`);
      } else {
        setCatMessage("Errore server durante la rimozione");
      }
    } finally {
      setCatLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar />
      <main className="flex-1 p-8 max-w-7xl mx-auto">
        <div className="flex gap-8">
          {/* Lista categorie */}
          <section className="flex-1">
            <div
              className="bg-white shadow-lg p-4 w-full my-6 flex flex-col"
              style={{ maxHeight: "600px", overflowY: "auto" }}
            >
              <h3 className="text-lg font-semibold text-[#94c41c] mb-3">Lista Categorie</h3>
              <table className="table-auto w-full text-sm text-left text-black">
                <thead className="bg-[#94c41c] text-white sticky top-0 z-10">
                  <tr>
                    <th className="px-3 py-2">Nome Categoria</th>
                    <th className="px-3 py-2">Descrizione</th>
                    <th className="px-3 py-2">Attiva</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-center py-4 text-gray-500">
                        Nessuna categoria trovata.
                      </td>
                    </tr>
                  )}
                  {categories.map((cat) => (
                    <tr key={cat.id} className="border-b hover:bg-gray-50">
                      <td className="px-3 py-2 font-medium">{cat.name}</td>
                      <td className="px-3 py-2">{cat.description}</td>
                      <td className="px-3 py-2">
                        {cat.active ? (
                          <span className="text-green-700 font-semibold">Attiva</span>
                        ) : (
                          <span className="text-red-600 font-semibold">Inattiva</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {/* Form aggiungi / rimuovi categoria */}
          <section className="w-80 flex flex-col gap-8">
            {/* Aggiungi categoria */}
            <form onSubmit={handleAddCategory} className="border border-gray-300 rounded-md p-6">
              <h3 className="text-xl font-semibold mb-4 text-[#94c41c]">Aggiungi Categoria</h3>
              <label className="block text-[#94c41c] font-medium mb-1">Nome Categoria</label>
              <input
                type="text"
                value={addName}
                onChange={(e) => setAddName(e.target.value)}
                className="w-full border border-black text-black rounded-md px-3 py-2 mb-4"
                placeholder="Nome categoria"
              />
              <label className="block text-[#94c41c] font-medium mb-1">Descrizione</label>
              <input
                type="text"
                value={addDesc}
                onChange={(e) => setAddDesc(e.target.value)}
                className="w-full border border-black text-black rounded-md px-3 py-2 mb-6"
                placeholder="Descrizione categoria"
              />
              <button
                type="submit"
                disabled={catLoading}
                className="w-full bg-[#94c41c] hover:bg-green-700 text-white font-semibold py-2 rounded-md"
              >
                {catLoading ? "Caricamento..." : "Aggiungi Categoria"}
              </button>
            </form>

            {/* Rimuovi categoria */}
            <div className="border border-gray-300 rounded-md p-6">
              <h3 className="text-xl font-semibold mb-4 text-[#94c41c]">Rimuovi Categoria</h3>
              <label className="block text-[#94c41c] font-medium mb-2">Seleziona Categoria</label>
              <select
                value={selectedCategoryId}
                onChange={(e) => setSelectedCategoryId(e.target.value)}
                className="w-full border border-black text-black rounded-md px-3 py-2 mb-6"
              >
                <option value="">-- Seleziona categoria --</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <button
                onClick={handleRemoveCategory}
                disabled={catLoading}
                className="w-full bg-[#94c41c] hover:bg-green-700 text-white font-semibold py-2 rounded-md"
              >
                {catLoading ? "Caricamento..." : "Rimuovi Categoria"}
              </button>
            </div>

            {/* Messaggio di stato */}
            {catMessage && (
              <div
                className={`mt-4 p-3 rounded ${
                  catMessage.startsWith("✅") ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                }`}
              >
                {catMessage}
              </div>
            )}
          </section>
        </div>
      </main>
    </div>
  );
};

export default ManageCategory;
